import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { LayoutModule } from "../theme/layouts/layout.module";
import { TripExpenseComponent } from "./trip-expense.component";

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

// const routes: Routes = [
//     {
//         path: "",
//         component: TripExpenseComponent,
//     },
// ];

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        // RouterModule.forChild(routes),
        LayoutModule,
        HttpClientModule,
        FormsModule,
    ],
    exports: [RouterModule, TripExpenseComponent],
    declarations: [TripExpenseComponent],
    providers: [],
})
export class TripExpenseModule { }
